import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let _cache = null;
const _subs = new Set();

const _notify = () => _subs.forEach((fn) => fn(_cache));

/**
 * useContent — single shared content map.
 * t(key, fallback?) returns the live string or fallback (or the key itself).
 */
export function useContent() {
  const [content, setContent] = useState(_cache || {});

  useEffect(() => {
    const sub = (c) => setContent(c || {});
    _subs.add(sub);
    if (!_cache) {
      api.get("/content")
        .then((r) => {
          _cache = r.data?.content || {};
          _notify();
        })
        .catch(() => { _cache = {}; _notify(); });
    } else {
      sub(_cache);
    }
    return () => _subs.delete(sub);
  }, []);

  const t = (key, fallback = "") => {
    if (content && content[key] !== undefined) return content[key];
    return fallback || key;
  };
  return { t, content };
}

/** Force-refresh the in-memory cache (use after admin saves). */
export async function refreshContent() {
  try {
    const r = await api.get("/content");
    _cache = r.data?.content || {};
    _notify();
    return _cache;
  } catch {
    return _cache;
  }
}
